import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { formatCurrency } from '../common/common';

const RoundedLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.palette.grey[200],
    '& .MuiLinearProgress-bar': {
        borderRadius: 4,
        backgroundColor: theme.palette.secondary.main,
    },
}));

const ActionprogresView = (props) => {
    const getPercentActualFromPotential = (actual, potential) => {
        if (potential === 0) return 0;
        return (actual / potential) * 100;
    };

    const percent = getPercentActualFromPotential(props.salesactual, props.salespotential);

    return (
        <Box sx={{ width: '100%' }}>
            <RoundedLinearProgress variant="determinate" value={Math.min(percent, 100)} />
            <Typography variant="caption" sx={{ color: 'text.secondary', mt: 0.5, display: 'block' }}>
                {formatCurrency(Math.round(props.salesactual), 2, props.currency)} / {formatCurrency(Math.round(props.salespotential), 2, props.currency)}
                {' '}({Math.round(percent)}%)
            </Typography>
        </Box>
    );
};

export default ActionprogresView;
